module.exports = __webpack_public_path__ + "img/icon-tool-truck.10c1779a.svg";